export const Emails = {
  Wellness: 'wellness@wagwalking.com',
} as const;
